import * as React from "react";
import DragableCard from "../DragableCard";
import Toggle from "../Toggle/Toggle";

const ProposalInfo = ({
  setState,
  data,
  handleChangeFile,
  index,
  viewMode,
  isVacant,
  setVacant,
  type
}) => {
  return (
    <div className="">
      <div className="" style={{marginTop: '40px'}}>
      <Toggle onChange={()=>{setVacant()}} value={isVacant} checked={isVacant} name={'Vacant'}/>
        <DragableCard
          setState={setState}
          index={index}
          data={data}
          handleChangeFile={handleChangeFile}
          viewMode={viewMode}
          type={type}
        />
      </div>
    </div>
  );
};

export default ProposalInfo;
